import React from 'react';
import { Modal, ListGroup, Alert, Button } from '@themesberg/react-bootstrap';
import { formatDate } from '../../utils/dateUtils';

const AttendanceModal = ({
  show,
  onHide,
  user,
  events,
  loading,
  error
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Eventos de Hoy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <strong>Eventos de hoy para: {user?.email}</strong>
        </div>

        {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
        
        {!loading && !error && events.length > 0 && (
          <div className="mt-3">
            <h6>Eventos encontrados:</h6>
            <ListGroup>
              {events.map((event, index) => (
                <ListGroup.Item key={index}>
                  <div>
                    <strong>{event.summary || 'Sin título'}</strong>
                    <br />
                    <small className="text-muted">
                      Inicio: {formatDate(event.start?.dateTime || event.start?.date)}
                      <br />
                      Fin: {formatDate(event.end?.dateTime || event.end?.date)}
                    </small>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        )}
        
        {!loading && !error && events.length === 0 && (
          <Alert variant="info" className="mt-3">No se encontraron eventos para este usuario.</Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={onHide}
          style={{
            backgroundColor: '#C5292B',
            borderColor: '#C5292B',
            color: 'white'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#A02225';
            e.target.style.borderColor = '#A02225';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#C5292B';
            e.target.style.borderColor = '#C5292B';
          }}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AttendanceModal;